/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import { GET_ASSESSMENT_DETAILS } from '../resources/endPoint';

export const getAssessementDetails = (userId) => {
  const url = userId ? `${GET_ASSESSMENT_DETAILS}?userId=${userId}` : GET_ASSESSMENT_DETAILS;

  return {
    url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.INTEGRATION_MS,
  };
};
